import React from 'react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import testimonialImg1 from '../../assets/images/testimonial/testimonial-2-1.png';
import testimonialImg2 from '../../assets/images/testimonial/testimonial-2-2.png';
import testimonialImg3 from '../../assets/images/testimonial/testimonial-2-3.png';
import testimonialRightImg from '../../assets/images/artwer/project-2-antislip-apeldoorn.jpg';

// TODO: vervang door 2-3 échte referenties (klant levert aan).
export const testimonials = [
  {
    imgSrc: testimonialImg1,
    name: 'Particuliere klant',
    company: 'Hilversum',
    text: 'Vooraf een heldere offerte, tijdens het werk korte lijnen en netjes opgeleverd op de afgesproken datum. Precies zoals beloofd — geen verrassingen.',
  },
  {
    imgSrc: testimonialImg2,
    name: 'VvE-bestuur',
    company: 'Amsterdam',
    text: 'Eén aanspreekpunt van opname tot oplevering. Geen onaangekondigd meerwerk en een duidelijke planning. Fijn dat je rechtstreeks met de vakman schakelt.',
  },
  {
    imgSrc: testimonialImg3,
    name: 'Vastgoedbeheerder',
    company: 'Bussum',
    text: 'Vakkundig herstel met het Soprema-systeem. Duidelijke planning, nette werkplek en minimale overlast. Een betrouwbare partner voor onderhoud.',
  },
];

const swiperOptions = {
  modules: [Autoplay, Pagination, Navigation],
  slidesPerView: 1,
  spaceBetween: 30,
  speed: 2000,
  autoplay: { delay: 7000, disableOnInteraction: false },
  loop: true,
  navigation: { nextEl: '.swiper-button-next1', prevEl: '.swiper-button-prev1' },
  pagination: { el: '.swiper-dot-style1', type: 'bullets', clickable: true },
  breakpoints: {
    0: { spaceBetween: 0, slidesPerView: 1 },
    375: { spaceBetween: 0, slidesPerView: 1 },
    575: { spaceBetween: 0, slidesPerView: 1 },
    768: { spaceBetween: 30, slidesPerView: 1 },
    992: { spaceBetween: 30, slidesPerView: 1 },
    1200: { spaceBetween: 30, slidesPerView: 1 },
    1320: { spaceBetween: 30, slidesPerView: 1 },
  },
};

export default function TestimonialTwo() {
  return (
    <>
      <section className="testimonial-two" id="referenties">
        <div className="container">
          <div className="section-title text-center">
            <div className="section-title__tagline-box">
              <span className="section-title__tagline">Referenties</span>
            </div>
            <h2 className="section-title__title">
              Wat klanten <span>over ons zeggen</span>
            </h2>
          </div>
          <div className="row">
            <div className="col-xl-6 col-lg-6">
              <div className="testimonial-two__left">
                <Swiper {...swiperOptions}>
                  {testimonials.map((testimonial, index) => (
                    <SwiperSlide key={index}>
                      <div className="testimonial-two__single">
                        <div className="testimonial-two__quote">
                          <span className="icon-quote"></span>
                        </div>
                        <div className="testimonial-two__client-info">
                          <div className="testimonial-two__client-img">
                            <img src={testimonial.imgSrc} alt="" loading="lazy" />
                          </div>
                          <div className="testimonial-two__client-content">
                            <h3>{testimonial.name}</h3>
                            <p>{testimonial.company}</p>
                          </div>
                        </div>
                        <p className="testimonial-two__text">
                          {testimonial.text}
                        </p>
                        <div className="testimonial-two__ratting">
                          <span className="icon-star"></span>
                          <span className="icon-star"></span>
                          <span className="icon-star"></span>
                          <span className="icon-star"></span>
                          <span className="icon-star"></span>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6">
              <div className="testimonial-two__right">
                <div className="testimonial-two__img">
                  <img
                    src={testimonialRightImg}
                    alt="Antislip eindlaag in een garage in Apeldoorn"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
